import React from 'react';
import { BrowserRouter, Route, Navigate, Routes } from 'react-router-dom';
import { StyledEngineProvider, ThemeProvider } from '@mui/material/styles';
import Fade from '@mui/material/Fade';
import GlobalStyles from '@mui/material/GlobalStyles';
import { styles, theme } from 'daaas-ui';
import { SnackbarProvider } from 'notistack';
import Localization from './Localization';
import SnackbarNotistack from '../components/UI/SnackbarNotistack';

// Components
import DefaultLayout from '../layouts/Default';
import ErrorLayout from '../layouts/Error';

// Pages
import AAW from '../pages/AAW';
import CAE from '../pages/CAE';
import GAE from '../pages/GAE';
import LandingPage from '../pages/Landing';
import AboutPage from '../pages/About';
import Hub from '../pages/Hub';
import HubVdl from '../pages/HubVdl';
import Pricing from '../pages/Pricing';
import FAQ from '../pages/FAQ';
import NotFound from '../pages/404';
// import DownloadVetted from '../pages/DownloadVetted';
import TermsAndConditions from '../pages/TermsAndConditions';

import ScrollToTop from '../scrollToTop';
import DoRedirects from '../doRedirects';
import {
  MsalExpiredSessionAlert,
  RedirectedFromAuthPageAlert,
} from '../components/UI/Dialogs';
// import Upload from '../pages/Upload';

const globalStyles = <GlobalStyles styles={styles} />;

export default function AppRouter() {
  return (
    <BrowserRouter
      future={{
        v7_relativeSplatPath: true,
        v7_startTransition: true,
      }}
    >
      <DoRedirects />
      <ScrollToTop />
      <StyledEngineProvider injectFirst>
        <ThemeProvider theme={theme}>
          <SnackbarProvider
            maxSnack={3}
            autoHideDuration={6000}
            TransitionComponent={Fade}
            preventDuplicate
            Components={{
              success: SnackbarNotistack,
            }}
          >
            <AllRoutes />
          </SnackbarProvider>
        </ThemeProvider>
      </StyledEngineProvider>
    </BrowserRouter>
  );
}

function Login() {
  return <div />;
}

function AllRoutes() {
  return (
    <>
      {globalStyles}
      <Routes>
        <Route
          path="/"
          element={<Navigate replace to="/data-analytics-services/overview" />}
        />
        <Route
          path="data-analytics-services"
          element={<Navigate replace to="/data-analytics-services/overview" />}
        />
        <Route
          path="services-analyse-donnees"
          element={<Navigate replace to="/services-analyse-donnees/apercu" />}
        />
        {/* We want to provide a blank page for the login redirect to ensure the redirect hash is not mangled by the react router */}
        <Route path="login" element={<Login />} />
        <Route
          path="data-analytics-services/overview"
          element={
            <Localization>
              <DefaultLayout>
                {/* When a user isn't signed in and tries to go to an auth page, we redirect them to /overview or /apercu, and show a popup */}
                <RedirectedFromAuthPageAlert />
                <MsalExpiredSessionAlert />
                <LandingPage />
              </DefaultLayout>
            </Localization>
          }
        />
        <Route
          path="services-analyse-donnees/apercu"
          element={
            <Localization>
              <DefaultLayout>
                {/* When a user isn't signed in and tries to go to an auth page, we redirect them to /overview or /apercu, and show a popup */}
                <RedirectedFromAuthPageAlert />
                <MsalExpiredSessionAlert />
                <LandingPage />
              </DefaultLayout>
            </Localization>
          }
        />
        <Route
          path="data-analytics-services/aboutdas"
          element={
            <Localization>
              <DefaultLayout>
                <MsalExpiredSessionAlert />
                <AboutPage />
              </DefaultLayout>
            </Localization>
          }
        />
        <Route
          path="services-analyse-donnees/apropossad"
          element={
            <Localization>
              <DefaultLayout>
                <MsalExpiredSessionAlert />
                <AboutPage />
              </DefaultLayout>
            </Localization>
          }
        />
        <Route
          path="data-analytics-services/aaw"
          element={
            <Localization>
              <DefaultLayout>
                <MsalExpiredSessionAlert />
                <AAW />
              </DefaultLayout>
            </Localization>
          }
        />
        <Route
          path="services-analyse-donnees/etaa"
          element={
            <Localization>
              <DefaultLayout>
                <MsalExpiredSessionAlert />
                <AAW />
              </DefaultLayout>
            </Localization>
          }
        />
        <Route
          path="data-analytics-services/cae"
          element={
            <Localization>
              <DefaultLayout>
                <MsalExpiredSessionAlert />
                <CAE />
              </DefaultLayout>
            </Localization>
          }
        />
        <Route
          path="services-analyse-donnees/eac"
          element={
            <Localization>
              <DefaultLayout>
                <MsalExpiredSessionAlert />
                <CAE />
              </DefaultLayout>
            </Localization>
          }
        />
        <Route
          path="data-analytics-services/gae"
          element={
            <Localization>
              <DefaultLayout>
                <MsalExpiredSessionAlert />
                <GAE />
              </DefaultLayout>
            </Localization>
          }
        />
        <Route
          path="services-analyse-donnees/eag"
          element={
            <Localization>
              <DefaultLayout>
                <MsalExpiredSessionAlert />
                <GAE />
              </DefaultLayout>
            </Localization>
          }
        />
        <Route
          path="data-analytics-services/hub"
          element={
            <Localization>
              <DefaultLayout>
                {/* Not needed here because page should already be re-routed to /overview in RedirectFromAuthPagesIfNoValidToken: <MsalExpiredSessionAlert /> */}
                <Hub />
              </DefaultLayout>
            </Localization>
          }
        />
        <Route
          path="services-analyse-donnees/guichet"
          element={
            <Localization>
              <DefaultLayout>
                {/* Not needed here because page should already be re-routed to /overview in RedirectFromAuthPagesIfNoValidToken: <MsalExpiredSessionAlert /> */}
                <Hub />
              </DefaultLayout>
            </Localization>
          }
        />
        <Route
          path="data-analytics-services/vdl-hub"
          element={
            <Localization>
              <DefaultLayout>
                {/* Not needed here because page should already be re-routed to /overview in RedirectFromAuthPagesIfNoValidToken: <MsalExpiredSessionAlert /> */}
                <HubVdl />
              </DefaultLayout>
            </Localization>
          }
        />
        <Route
          path="services-analyse-donnees/guichet-lvd"
          element={
            <Localization>
              <DefaultLayout>
                {/* Not needed here because page should already be re-routed to /overview in RedirectFromAuthPagesIfNoValidToken: <MsalExpiredSessionAlert /> */}
                <HubVdl />
              </DefaultLayout>
            </Localization>
          }
        />
        {/* <Route
          path="data-analytics-services/vdl-hub/upload"
          element={
            <Localization>
              <DefaultLayout>
                Not needed here because page should already be re-routed to /overview in RedirectFromAuthPagesIfNoValidToken: <MsalExpiredSessionAlert />
                <Upload />
              </DefaultLayout>
            </Localization>
          }
        />
        <Route
          path="services-analyse-donnees/guichet-lvd/televerser"
          element={
            <Localization>
              <DefaultLayout>
                Not needed here because page should already be re-routed to /overview in RedirectFromAuthPagesIfNoValidToken: <MsalExpiredSessionAlert />
                <Upload />
              </DefaultLayout>
            </Localization>
          }
        />
        <Route
          path="data-analytics-services/vdl-hub/download"
          element={
            <Localization>
              <DefaultLayout>
                Not needed here because page should already be re-routed to /overview in RedirectFromAuthPagesIfNoValidToken: <MsalExpiredSessionAlert />
                <DownloadVetted />
              </DefaultLayout>
            </Localization>
          }
        />
        <Route
          path="services-analyse-donnees/guichet-lvd/telecharger"
          element={
            <Localization>
              <DefaultLayout>
                Not needed here because page should already be re-routed to /overview in RedirectFromAuthPagesIfNoValidToken: <MsalExpiredSessionAlert />
                <DownloadVetted />
              </DefaultLayout>
            </Localization>
          }
        /> */}
        <Route
          path="data-analytics-services/pricing"
          element={
            <Localization>
              <DefaultLayout>
                <MsalExpiredSessionAlert />
                <Pricing />
              </DefaultLayout>
            </Localization>
          }
        />
        <Route
          path="services-analyse-donnees/cout"
          element={
            <Localization>
              <DefaultLayout>
                <MsalExpiredSessionAlert />
                <Pricing />
              </DefaultLayout>
            </Localization>
          }
        />
        <Route
          path="data-analytics-services/faq"
          element={
            <Localization>
              <DefaultLayout>
                <MsalExpiredSessionAlert />
                <FAQ />
              </DefaultLayout>
            </Localization>
          }
        />
        <Route
          path="services-analyse-donnees/faq"
          element={
            <Localization>
              <DefaultLayout>
                <MsalExpiredSessionAlert />
                <FAQ />
              </DefaultLayout>
            </Localization>
          }
        />
        <Route
          path="data-analytics-services/terms-and-conditions"
          element={
            <Localization>
              <DefaultLayout>
                <MsalExpiredSessionAlert />
                <TermsAndConditions />
              </DefaultLayout>
            </Localization>
          }
        />
        <Route
          path="services-analyse-donnees/conditions-d-utilisation"
          element={
            <Localization>
              <DefaultLayout>
                <MsalExpiredSessionAlert />
                <TermsAndConditions />
              </DefaultLayout>
            </Localization>
          }
        />
        <Route
          path="*"
          element={
            <ErrorLayout>
              <NotFound />
            </ErrorLayout>
          }
        />
      </Routes>
    </>
  );
}
